if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.querySelector(".swiper-wrapper");
      this.loaded = false;
      this.style.display = "block";
      this.observe();
    }

    observe() {
      if (!this.dataset.lazyLoad || !("IntersectionObserver" in window)) {
        this.load();
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.observer.disconnect();
            this.load();
          });
        },
        { rootMargin: "700px 0px" },
      );
      this.observer.observe(this);
    }

    load() {
      if (this.loaded) return;
      this.loaded = true;

      if (this.dataset.source === "recent") {
        this.getRecentlyViewed();
        return;
      }

      if (
        this.dataset.source === "similiar" ||
        this.dataset.source === "complementary"
      ) {
        this.getProductListView(this.dataset.source);
        return;
      }

      this.getRecommendations();
    }

    getRecommendations() {
      if (!this.dataset.productId) return;
      fetch(
        `${window.Shopify.routes.root}recommendations/products?product_id=${this.dataset.productId}&limit=8&section_id=product-recommendations-content&intent=${this.dataset.source}`,
      )
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          const cards = doc.querySelector(".swiper-wrapper");
          if (cards?.querySelector("product-card")) {
            this.wrapper.innerHTML = cards.innerHTML;
          }
          this.finalize();
        })
        .catch(() => this.finalize());
    }

    getProductListView(source) {
      if (!this.dataset.productHandle) return;
      fetch(`/products/${this.dataset.productHandle}?view=recommendations-${source}`)
        .then((response) => response.text())
        .then((html) => {
          if (html.trim()) {
            this.wrapper.innerHTML = html;
          }
          this.finalize();
        })
        .catch(() => this.finalize());
    }

    getRecentlyViewed() {
      const recent = localStorage.getItem("pdp_recently_viewed")
        ? JSON.parse(localStorage.getItem("pdp_recently_viewed"))
        : [];
      const requests = [];

      if (
        recent.length < 1 ||
        (recent.length === 1 && recent[0] === this.dataset.productHandle)
      ) {
        this.finalize();
        return;
      }

      recent.forEach((handle) => {
        if (handle !== this.dataset.productHandle) {
          requests.push(`/products/${handle}?view=card`);
        }
      });

      Promise.all(requests.map((url) => fetch(url).then((response) => response.text())))
        .then((responses) => {
          responses.forEach((html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");
            if (doc.querySelectorAll("product-card").length === 1) {
              this.wrapper.innerHTML += `<div class="swiper-slide">${html}</div>`;
            }
          });
          this.finalize();
        })
        .catch(() => this.finalize());
    }

    finalize() {
      if (this.wrapper?.querySelector("product-card")) {
        this.initCarousel();
        this.initWishlistEvents();
        return;
      }

      if (this.closest(".product__complementary-carousel")) {
        this.closest(".product__complementary-carousel").remove();
      } else {
        this.remove();
      }
    }

    initWishlistEvents() {
      if (!window.iWish) return;
      this.querySelectorAll("product-card").forEach((card) => {
        const trigger = card.querySelector(".product-card__wish");
        if (!trigger) return;
        if (iWish.isInWishlist(trigger.dataset.variant)) {
          trigger.classList.add("iwishAdded");
        }
        trigger.addEventListener("click", (event) => {
          event.preventDefault();
          if (iWish.isInWishlist(trigger.dataset.variant)) {
            trigger.classList.remove("iwishAdded");
            iWish.iwishRemove(trigger.dataset.variant, trigger.dataset.product);
          } else {
            trigger.classList.add("iwishAdded");
            iWish.iwishAdd(trigger.dataset.variant, trigger.dataset.product, 1);
          }
        });
      });
    }

    initCarousel() {
      const scrollbar = this.querySelector(".swiper-scrollbar");
      const prev = this.querySelector(".arrow--left");
      const next = this.querySelector(".arrow--right");
      new Swiper(this.querySelector(".swiper-container"), {
        // Przewijanie touchpadem: dwa palce w poziomie ruszaja karuzela.
        // forceToAxis pilnuje, zeby ruch w pionie nadal przewijal strone,
        // releaseOnEdges oddaje gest stronie na koncu karuzeli.
        mousewheel: { enabled: true, forceToAxis: true, releaseOnEdges: true, thresholdDelta: 8 },
        loop: false,
        grabCursor: false,
        speed: 500,
        spaceBetween: 8,
        slidesPerView: 2,
        watchSlidesProgress: true,
        scrollbar: { el: scrollbar, enabled: true },
        navigation: { nextEl: next, prevEl: prev },
        breakpoints: {
          768: { spaceBetween: 16, slidesPerView: 3 },
          992: { spaceBetween: 16, slidesPerView: this.dataset.slidesPerView },
        },
      });
      this.style.display = "block";
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    }
  }
  customElements.define("product-recommendations", ProductRecommendations);
}
